import { createApp } from "vue";
import App from "./App.vue";
import router from "./router/index";
import store from "./store/index";

import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import ElementPlus from "element-plus";
import locale from 'element-plus/lib/locale/lang/zh-cn';
import "element-plus/dist/index.css";
import "@/assets/iconfont/iconfont.css";
import "@/assets/css/element.less";
import "@/assets/css/sidebar.less";
import "@/assets/css/base.less";

const app = createApp(App);

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

app.use(ElementPlus, { locale });
app.use(router);
app.use(store);
app.mount("#app");
app.config.warnHandler = () => null
